<template>
  <SolshareSelector
    :meter-value="serialNum"
    :meter-select-on-change="onMeterChange"
    title="Site Configuration"
    description="Select a Solshare to start configuration."
  />
  <SolshareInfo
    v-if="serialNum && systemData"
    :data="systemData"
    :oldConfig="originalConfig"
    :serialNum="serialNum"
    :loading="loading"
    :is-commissioned="isCommissioned"
    @config-saved="refreshSolshareConfig"
  />
  <template v-else-if="loading">
    <div class="site-configuration-tab-loading">
      <a-spin :spinning="true" />
      <p>Loading...</p>
    </div>
  </template>
</template>

<script>
import SolshareSelector from '@/components/SolshareSelector';
import SolshareInfo from '@/components/Tabs/SiteConfigurationTab/components/SolshareInfo';
import { SEARCH_METER_CODE } from '@/utils/constants';
import { SOLAR_DELIVERY_METHOD } from '../../../utils/constants';
export default {
  name: 'SiteConfigurationTab',
  components: { SolshareSelector, SolshareInfo },
  data() {
    return {
      serialNum: '',
      systemData: null,
      originalConfig: null,
      loading: false,
      isCommissioned: true,
    };
  },
  methods: {
    buildSystemData(serialNum, payload) {
      return {
        ...payload,
        config: {
          ...payload.config,
          algorithm_type: serialNum.startsWith('2P')
            ? Array.isArray(payload.config?.algo_weight) &&
              payload.config.algo_weight.length > 0
              ? SOLAR_DELIVERY_METHOD.UNEQUAL_ALLOCATION
              : SOLAR_DELIVERY_METHOD.NET_METERING
            : payload.config?.algorithm_type,
        },
      };
    },
    async loadSystemInfo(serialNum) {
      const {
        data: { code, payload },
      } = await this.$http.get(this.$api.getSolshareInfo(serialNum));
      if (code === SEARCH_METER_CODE.READY_TO_GO) {
        this.isCommissioned = true;
        this.systemData = this.buildSystemData(serialNum, payload);
        this.originalConfig = Object.freeze(
          JSON.parse(JSON.stringify(this.systemData.config)),
        );
      } else if (code === SEARCH_METER_CODE.NOT_COMMISSIONED) {
        this.isCommissioned = false;
        this.systemData = this.buildSystemData(serialNum, payload || {});
        this.originalConfig = this.systemData.config
          ? Object.freeze(JSON.parse(JSON.stringify(this.systemData.config)))
          : null;
      } else {
        this.$message.error(`Get Solshare configuration failed: code ${code}`);
        this.systemData = null;
      }
    },
    async refreshSolshareConfig() {
      if (!this.serialNum) {
        return;
      }
      try {
        await this.loadSystemInfo(this.serialNum);
      } catch (e) {
        this.$message.error(`Get Solshare configuration failed: ${e}`);
      }
    },
    async onMeterChange(serialNum) {
      this.serialNum = serialNum;
      this.loading = true;
      this.isCommissioned = true;

      // Drop the stale payload so SolshareInfo component is not mounted until the new fetch completes.
      // Otherwise ConnectionGroup initialises weights while data
      //  is still null and never picks up the real algo_weight / systemSize.
      this.systemData = null;
      this.originalConfig = null;

      try {
        await this.loadSystemInfo(serialNum);
      } catch (e) {
        this.$message.error(`Get Solshare configuration failed: ${e}`);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.site-configuration-tab-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
